export function getFbClientId() {
	const result = /_fbp=(fb\.1\.\d+\.\d+)/.exec(window.document.cookie);
	if (!(result && result[1])) {
		return null;
	}
	return result[1];
}
